import { trackFirstMessageSend } from '../components/start_chat_container/tracking';

const FLOCTORY_CHECK_TIMEOUT = 1500;
/**
 * Название события, которое отправляем в dataLayer.push,
 * для показа системного попапа разрешения пуш уведомлений
 */
export const FLOCKTORY_KEY_EVENT = 'show_push_cian_site';

export const checkFlocktoryLoad: () => Promise<IFlocktory> = () => {
  return new Promise(resolve => {
    let timeIntervalFlocktoryCheck: number;

    const flocktoryAttempt = () => {
      // tslint:disable-next-line
      if (window.flocktory && typeof window.flocktory.getSubscriptionStatus === 'function') {
        window.clearTimeout(timeIntervalFlocktoryCheck);

        return resolve(window.flocktory);
      }

      timeIntervalFlocktoryCheck = window.setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
    };

    timeIntervalFlocktoryCheck = window.setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
  });
};

export function sendSystemPushNotificationPopup(pushSubscribed: boolean, isPushCheck: boolean) {
  if (window.dataLayer && isPushCheck) {
    window.dataLayer.push({ event: FLOCKTORY_KEY_EVENT });
  }

  trackFirstMessageSend(pushSubscribed, isPushCheck);
}
